import apiConfig, { ENVIRONMENT_PRODUCTION } from '../appConfig/apiConfig'

const flagConfig = [
  { name: 'TPLUS_REVAMP', stage: true, prod: true },
  { name: 'TPLUS_LEAD_FORM_V2', stage: true, prod: false },
]

export const flag = (flagName) => {
  const { stage, prod } = flagConfig.find(({ name }) => name === flagName)

  if (apiConfig.environment === ENVIRONMENT_PRODUCTION) {
    return prod
  }

  return stage
}
